import React from "react";
import Box from "@mui/material/Box";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MaliTablolar from "./MaliTablolar";
import Giderler from "./Giderler";
import Kisiler from "./kisiler/Kisiler";
import Hesaplar from "./hesaplar/Hesaplar";
import SistemYonetimi from "./SistemYonetimi";
import {useNavigate, useParams} from "react-router-dom";
import CustomTabPanel from "src/components/CustomTabPanel";
import {Assessment, ReceiptLong, AccountBalance, People, Settings} from '@mui/icons-material';

const tabMap: { [key: string]: number } = {
    "mali-tablolar": 0,
    "giderler": 1,
    "hesaplar": 2,
    "kisiler": 3,
    "ayarlar": 4
};

const indexMap: { [key: number]: string } = {
    0: "mali-tablolar",
    1: "giderler",
    2: "hesaplar",
    3: "kisiler",
    4: "ayarlar"
};

const Yonetim = () => {
    const {tab} = useParams();
    const navigate = useNavigate();
    const value = tab ? tabMap[tab] ?? 0 : 0;

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        navigate(`/Logbook/yonetim/${indexMap[newValue]}`);
    };

    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper', position: 'sticky', top: 0, zIndex: 10 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        px: { xs: 1, md: 3 },
                        '& .MuiTab-root': { 
                            fontWeight: 700, 
                            minHeight: 64, 
                            textTransform: 'none', 
                            fontSize: '0.95rem',
                            color: 'text.secondary'
                        },
                        '& .Mui-selected': { color: 'primary.main' },
                        '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' }
                    }}
                >
                    <Tab icon={<Assessment sx={{ fontSize: 20 }} />} iconPosition="start" label="Mali Tablolar" id={`simple-tab-${0}`}/>
                    <Tab icon={<ReceiptLong sx={{ fontSize: 20 }} />} iconPosition="start" label="Giderler" id={`simple-tab-${1}`}/>
                    <Tab icon={<AccountBalance sx={{ fontSize: 20 }} />} iconPosition="start" label="Hesaplar" id={`simple-tab-${2}`}/>
                    <Tab icon={<People sx={{ fontSize: 20 }} />} iconPosition="start" label="Kişiler" id={`simple-tab-${3}`}/>
                    <Tab icon={<Settings sx={{ fontSize: 20 }} />} iconPosition="start" label="Ayarlar" id={`simple-tab-${4}`}/>
                </Tabs>
            </Box>

            <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                <CustomTabPanel value={value} index={0} sx={{ p: 0 }}>
                    <MaliTablolar/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1} sx={{ p: 0 }}>
                    <Giderler/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2} sx={{ p: 0 }}>
                    <Hesaplar/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3} sx={{ p: 0 }}>
                    <Kisiler/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4} sx={{ p: 0 }}>
                    <SistemYonetimi/>
                </CustomTabPanel>
            </Box>
        </Box>
    );
}

export default Yonetim;